import { BgVideo } from "./BgVideo";
import { Reveal } from "./Reveal";
import { img, srcSet, altOf } from "@/lib/media";
import { useLang } from "@/lib/i18n";

const POSTER = "/services-poster.jpg";
// Set to true to show the "What we design" cards again.
const SHOW_DESIGN_CARDS = false;
const CARD_THEMES = ["weddings", "birthdays-quinceaneras", "seasonal-holidays", "church-ceremonies", "arrangements-bouquets", null];

export const Services = ({ themes }) => {
  const { t, lang } = useLang();
  return (
    <section className="svc" id="services" data-testid="services-section">
      <div className="band" style={{ backgroundImage: `url(${POSTER})` }}>
        <BgVideo src="/videos/services.mp4" poster={POSTER} testId="services-video" />
        <div className="wrap">
          <Reveal>
            <h2>{t.services.h}</h2>
            <p className="lede">{t.services.lede}</p>
          </Reveal>
          <div className="steps">
            {t.services.steps.map(([h, p], i) => (
              <Reveal key={i} delay={i * 0.1}><div className="step" data-testid={`service-step-${i + 1}`}><h3>{i + 1}. {h}</h3><p>{p}</p></div></Reveal>
            ))}
          </div>
        </div>
      </div>
      {SHOW_DESIGN_CARDS && <div className="cards">
        <div className="wrap">
          <Reveal><h2 style={{ marginBottom: 32 }}>{t.services.design}</h2></Reveal>
          <div className="offer">
            {t.services.cards.map(([, h, p], i) => {
              const cover = themes.find((th) => th.id === CARD_THEMES[i])?.cover;
              return (
                <Reveal key={i} delay={(i % 3) * 0.08}>
                  <figure className={`card ${cover ? "" : "card-text"}`} data-testid={`design-card-${i + 1}`}>
                    {cover && (
                      <div className="card-img"><img loading="lazy" alt={altOf(cover, lang)} src={img(cover.file, 960)} srcSet={srcSet(cover.file)} sizes="(max-width:560px) 100vw, (max-width:900px) 50vw, 380px" /></div>
                    )}
                    <figcaption><h3>{h}</h3><p>{p}</p></figcaption>
                  </figure>
                </Reveal>
              );
            })}
          </div>
        </div>
      </div>}
    </section>
  );
};
